import { Box } from '@radix-ui/themes';

interface SignInDialogButtonProps {
  containerId: string;
}

export default function SignInDialogButton({
  containerId
}: SignInDialogButtonProps) {
  return (
    <Box
      width={{ initial: '100vw', sm: '360px' }}
      px='4'
    >
      <div id={containerId}></div>
    </Box>
  );
}
